import icon from "./../../../assets/images/user/AttendanceIcon.svg"
import noRecordFound from "../../../assets/images/empty-folder.png"
import { useApplyLeave } from "../context/ApplyLeaveContext";


export default function UserAttendance() {
  const { onLeaveTodayList } = useApplyLeave()

  return (
    <div className='UserAttendance p-5 h-[40%] lg:h-[37%]'>

      <div className=' flex justify-between'>
        <div className=' flex gap-3'>
          <img src={icon} alt="attendance-icon" className='h-[22px] w-[18px]' />
          <p className='text-[#D23B7D]'>Who's on leave</p>
        </div>

        {/* <p>Month: <span>Jan</span></p> */}
      </div>

      <div className="no-record leave-list flex justify-center h-full">
        <p className='flex justify-center items-center text-xl'> <img src={noRecordFound} alt="noRecord" className='user-norecord' />
        </p>
      </div>
    </div>

  );
}